<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="addFunctionalHelp()"
                    matTooltip="{{ 'add_record' | transloco }}"
                >
                    <mat-icon>add</mat-icon>
                    {{ "new_record" | transloco }}
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>
            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">
                    <div class="filter-item">
                        <pixl-free-filter-input
                            [label]="'name_or_id' | transloco"
                            [matIcon]="'search'"
                            [hint]="getSearchFilterHint()"
                            [minLength]="freeFilterLen"
                            (onKeyUpChange)="setFreeFilter($event)"
                        />
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>
                                {{ "Konsumenten" | transloco }}
                            </mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setConsumerFilter($event)"
                            >
                                @for (consumer of consumers$ | async; track consumer) {
                                <mat-option [value]="consumer.id">{{consumer.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>{{ "subjects" | transloco }}</mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setSubjectFilter($event)"
                            >
                                @for (subject of subjects$ | async; track subject) {
                                <mat-option [value]="subject.treeId">{{subject.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-item">
                        <pixl-type-cb
                            (onStateChange)="setKindFilter($event)"
                            [withoutNone]="false"
                            matLabelText="{{ 'type' | transloco }}"
                        />
                    </div>
                </div>
                <div class="main-toolbar-spacer-right"></div>
            </div>
            <div class="table-header-overlay"></div>
        </div>
    </div>

    <div class="table-container mat-elevation-z4">
        @if (functionalHelps$ | async; as functionalHelps) {
        <table
            mat-table
            [dataSource]="functionalHelps"
            matSort
            (matSortChange)="announceSortChange($event)"
        >
            <ng-container matColumnDef="edit-actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "actions" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let functionalHelp"
                >
                    <button
                        [class.btn-success]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="editFunctionalHelp(functionalHelp)"
                        matTooltip="{{ 'edit_record_hint' | transloco }}"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button
                        [class.btn-info]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Copy"
                        (click)="copyFunctionalHelp(functionalHelp)"
                        matTooltip="{{ 'copy_record_hint' | transloco }}"
                    >
                        <mat-icon>content_copy</mat-icon>
                    </button>
                    <button
                        [class.btn-danger]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Delete"
                        matTooltip="{{ 'delete_record_hint' | transloco }}"
                        (click)="deleteFunctionalHelp(functionalHelp)"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "name" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let functionalHelp"
                >{{ functionalHelp.name }}</td>
            </ng-container>
            <ng-container matColumnDef="consumer">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "application" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let functionalHelp"
                >
                @if (functionalHelp.consumers) {
                    {{ getConsumer(functionalHelp.consumers.id, true) }}
                } @else {
                ---
                }
            </td>
            </ng-container>
            <ng-container matColumnDef="exerciseKind">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "type" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let functionalHelp"
                >
                    <pixl-lang
                        [key]="functionalHelp.exerciseKind"
                        [keySuffix]="functionalHelp.exerciseSubKind?.toString()"
                    ></pixl-lang>
                </td>
            </ng-container>
            <ng-container matColumnDef="competency">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "subject" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let functionalHelp"
                >
                    @if (functionalHelp.subjects) {
                        {{ getSubject(functionalHelp.subjects.id, true) }}
                    } @else {
                    ---
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="created">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "created" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let functionalHelp"
                >{{ getCreatedDate(functionalHelp.id) | date }}</td>
            </ng-container>

            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [class.selected-row]="currentSelectedRow() === row.id"
            ></tr>
        </table>
        } @else {
            <pixl-table-loading-spinner [name]="'Funktionale Hilfen/Tipps'" />
        }
        <mat-paginator
            [pageIndex]="pageChange().pageIndex"
            [pageSize]="pageChange().pageSize"
            [pageSizeOptions]="[25, 50, 100]"
            [length]="totalItems">
        </mat-paginator>
    </div>
</div>